// src/pages/NotFound.js
import React from 'react';

function NotFoundPage() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        background: '#fff',
        padding: '40px 30px',
        borderRadius: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/753/753345.png"
          alt="Not Found"
          style={{ width: 100, marginBottom: 20 }}
        />
        <h2>Page Not Found</h2>
        <p style={{ color: '#6c757d', marginBottom: 20 }}>
          Oops! We couldn't find the page you're looking for.<br />
          Please check the address and try again.
        </p>
        <p style={{ fontWeight: 'bold', color: '#6c757d' }}>Error Code: 404</p>
        <a
          href="/dashboard"
          style={{
            background: '#007bff',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: 8,
            textDecoration: 'none',
            fontWeight: 600,
            display: 'inline-block',
            marginTop: 10
          }}
        >
          Go Back to Home
        </a>
      </div>
    </div>
  );
  // return (
  //   <div style={{ textAlign: 'center', padding: '100px 20px' }}>
  //     <h1>404 - Page Not Found</h1>
  //     <p>The page you're looking for doesn't exist.</p>
  //     <a href="/dashboard" style={{ color: '#007bff' }}>Go back to Home</a>
  //   </div>
  // );
};

export default NotFoundPage;
